import { useDashboardDataProvider } from 'features/dashboard'
import { getResourceName } from 'features/resources'
import { TopDevicesCard } from 'procyon-ui'
import TopDevicesCardSkeleton from './TopDevicesCardSkeleton'
import React, { useEffect, useMemo, useRef } from 'react'

const TopDevices = () => {
  const { heatMap, startDays, overallLoading, dashboardReady } = useDashboardDataProvider()
  const hasAnimatedRef = useRef(false)

  useEffect(() => {
    if (dashboardReady && !hasAnimatedRef.current) {
      hasAnimatedRef.current = true
    }
  }, [dashboardReady])

  useEffect(() => {
    hasAnimatedRef.current = false
  }, [startDays])

  const data = useMemo(() => {
    const sortedDevices = Object.values(heatMap.devices)
    sortedDevices.sort((a, b) => b.count - a.count)

    const top5 = sortedDevices.slice(0, 5)
    const totalCount = top5.reduce((prev, curr) => prev + curr.count, 0)

    return top5.map((d, i) => ({
      color: colors[i],
      name: getResourceName(d.device),
      sessions: d.count,
      total: `${Math.floor((d.count / totalCount) * 100)}%`,
      owner: getResourceName(d.owner)
    }))
  }, [heatMap.devices])

  return (
    <div>
      <TopDevicesCard
        style={{ height: 'auto', width: '100%', background: 'var(--color-common-bg-base)' }}
        className='!h-auto'
        caption={`by resource type last ${startDays} days`}
        items={data}
        title='Top Devices'
        animate={dashboardReady && !hasAnimatedRef.current} // animate only once
      />
    </div>
  )
}

const colors = ['#658BD3', '#94BD91', '#E4B761', '#61e48a', '#A6ABB6']

export { TopDevices }
